import React, { useState } from "react";
import Image from "components/image";
import ButtonLink from "components/button-link";
import RichText from "components/rich-text";

const ImageAssociatedText = ({ data }) => {
	const { title, items, cta } = data;
	const [activeItem, setActiveItem] = useState(0);

	return (
		<div className="mx-auto">
			{title && <h2 className="font-base md:text-center pt-4 pb-10">{title}</h2>}
			<div className="flex flex-col md:flex-row">
				<div className="w-full lg:w-3/5 xxl:w-2/3 md:pr-2 lg:pr-8">
					{items?.map((item, index) => (
						<div
							key={index}
							className={`p-6 border cursor-pointer ${activeItem === index ?
								"bg-white border-beige shadow-lg" : "bg-cream border-cream"} `}
							onClick={() => setActiveItem(index)}
						>
							<p className="text-xl font-semibold">{item.title}</p>
							{item.description && (
								<div className="py-4 text-sm md:text-base">
									<RichText data={{ content: item.description }} />
								</div>
							)}
							{item.image && activeItem === index && (
								<div className="block md:hidden">
									<Image image={item.image} className="mt-4" />
								</div>
							)}
						</div>
					))}
				</div>
				<div className="hidden md:flex w-full items-center justify-center lg:w-2/5 xxl:w-1/3">
					{items[activeItem]?.image ? (
						<Image image={items[activeItem].image}
							className="object-contain" alt="Selected Image" />
					) : (
						<div className="text-center text-gray-500">No image available</div>
					)}
				</div>
			</div>
			{cta && (
				<div className="text-center mt-8 flex justify-center">
					<ButtonLink data={cta} className="w-fit md:mb-7 font-bold" />
				</div>
			)}
		</div>
	);
};

export default ImageAssociatedText;